import React, { useState } from "react";
import {
  Container,
  ToggleWrapper,
  ToggleOption,
  DiscountBadge,
} from "../styles";
import { useTranslation } from "react-i18next";
import useBreakPoinst from "@hooks/useBreakPoinst";

const TogglePeriod = ({ subscriptionType, onChange }: any) => {
  const { t } = useTranslation();
  const { isPhone } = useBreakPoinst();

  function handleClick() {
    onChange(subscriptionType == "Yearly" ? "Monthly" : "Yearly");
  }
  return (
    <Container>
      <ToggleWrapper $isPhone={isPhone}>
        <ToggleOption
          $isActive={subscriptionType === "Yearly"}
          onClick={handleClick}
        >
          {t("chooseSubscription.yearly")}
          {<DiscountBadge>{t("chooseSubscription.discount")}</DiscountBadge>}
        </ToggleOption>
        <ToggleOption
          $isActive={subscriptionType === "Monthly"}
          onClick={handleClick}
        >
          {t("chooseSubscription.monthly")}
        </ToggleOption>
      </ToggleWrapper>
    </Container>
  );
};

export default TogglePeriod;
